var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMood = function SvgMood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mood_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M44 19.75c-9.941 0-18 8.059-18 18s8.059 18 18 18 18-8.059 18-18-8.059-18-18-18m11.03 29.03a15.545 15.545 0 1 1-21.95-22.016A15.545 15.545 0 0 1 55.03 48.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M39.2 33.55h-3v3h3zM51.8 33.55h-3v3h3zM44 47.35a7.8 7.8 0 0 0 7.8-7.8H36.2a7.8 7.8 0 0 0 7.8 7.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mood_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35559",
    result: "shape"
  })))));
};
export default SvgMood;